// extracted by mini-css-extract-plugin
export default {"profile-header":"profile-header_profile-header__Bk4OP","profile-header-info":"profile-header_profile-header-info__2vZrs","text-gap":"profile-header_text-gap__btGTx"};